import {Show, createEffect, createSignal, onMount} from 'solid-js'
import './loginOtp.css'
import {useIcon} from '../icon/useIcon'
import {FocusableProvider} from '../focus'
import {useSpatialNavigation} from '../../spatialNavigation'
import DeviceList from '../deviceList/deviceList'
import {useDispatch, useSelector} from '../../store'
import {generateOTPCode} from '@te/volt-store/lib/actions'
import {OtpInput} from '../otpInput/OtpInput'
import {useI18n} from '../../i18n'
import {useConfig} from '../config/useConfig'


const LoginOtp = (props: any) => {
    const icons = useIcon()
    const dispatch = useDispatch()
    const {getI18n} = useI18n()
    const {getConfig} = useConfig()
    const locale = useSelector((state: any) => state?.language?.locale)


    const {setFocus} = useSpatialNavigation()
    const [timer, setTimer] = createSignal({
        min: 0,
        sec:
            localStorage.getItem('timer') && localStorage.getItem('timer') !== '0'
                ? parseInt(localStorage.getItem('timer') || '0')
                : 59,
    })
    const [showResendButton, setShowResendButton] = createSignal<boolean>(false)

    const [pin, setPin] = createSignal<any>('')
    const [showDeviceList, setShowDeviceList] = createSignal<boolean>(false)

    const deviceList = useSelector((state: any) => state.devices)

    let interval: any = ''

    createEffect(() => {
        if (deviceList().deviceList.length > 0 && props.authenticationStatus === 'FAILED') {
            setShowDeviceList(true)
        }
    })

    onMount(() => startTimer())

    const handleResandOTP = () => {
        props?.resentOtp && props?.resentOtp()
        setShowResendButton(false)
        dispatch(generateOTPCode({serviceNumber: props.username}))
        setTimer({min: 0, sec: 59})
        if (interval) clearInterval(interval)
        startTimer()
    }

    const pinComponent = () => {
        return (
            <OtpInput
                length={4}
                onComplete={(pinCode: any) => {
                    localStorage.setItem('timer', timer().sec.toString())
                    setPin(pinCode)
                    props.onCompleteOtp(pinCode)
                }}
                onChange={() => {
                    setPin()
                }}
            />
        )
    }

    createEffect(() => {
        if (!showDeviceList()) {
            setFocus('resendbutton')
        }
    })

    createEffect(() => {
        if (timer()?.min === 0 && timer()?.sec === 0) {
            setShowResendButton(true)
            if (!showDeviceList()) {
                setFocus('resendbutton')
            }
            setTimer({min: 0, sec: 20})
            if (interval) clearInterval(interval)
            startTimer()
        }
    })

    const startTimer = () => {
        interval = setInterval(() => {
            if (timer()?.sec === 0 && timer()?.sec !== 0) {
                setTimer(value => {
                    return {min: value.min - 1, sec: 59}
                })
            } else if (timer()?.sec !== 0) {
                setTimer(value => {
                    return {min: value?.min, sec: value?.sec - 1}
                })
            }
        }, 1000)
    }

    const getArabicText = () => {
        const temp = props?.otpText?.split("*")
        const text = temp?.map((_: any, index: number) => index !== temp.length - 1 ? "*" : temp[temp.length - 1]?.split("")?.reverse()?.join(""))
        return text.join("")
    }

    return (
        <div
            class={`${getConfig().rtlLanguages.includes(locale()) ? 'appContainer rtl' : 'appContainer ltr'}`} 
            style={
                getConfig()?.client === 'starhub'
                  ? {
                    'background-image': `url(${icons.get('LoginBackdrop')})`,
                    'background-size': 'cover',
                    direction: `${getConfig().rtlLanguages.includes(locale()) ? 'rtl' : 'ltr'}`
                    }
                  : {}
              }
        >
            <div class="loginContainer">
                <div class="client_logo_loading_logout_screen"></div>
                <div class="otpDescription">
                    {getI18n()?.formatMessage(
                        {id: 'SOLO_OTP_DESCRIPTION'},
                        {title: getConfig().rtlLanguages.includes(locale()) ? getArabicText() : props.otpText}
                    )}
                </div>
                <div class="otp-container">
                    {showResendButton() && !showDeviceList() ? (
                        <FocusableProvider
                            id={`resendbutton`}
                            class="resendbutton"
                            focusKey={`resendbutton`}
                            onEnterPress={handleResandOTP}
                        >
                            {(focused: any) => (
                                <button
                                    class={`login-content-button-tv-new ${focused ? 'login-content-button-tv-new-focus' : ''}`}
                                    onClick={handleResandOTP}
                                    tabIndex={focused ? 0 : -1}
                                >
                                    {getI18n()?.formatMessage({id: 'RESEND_OTP'})}
                                </button>
                            )}
                        </FocusableProvider>
                    ) : !showDeviceList() ? (
                        pinComponent()
                    ) : null}
                </div>
                {!showResendButton() && (
                    <div class="otpDescription" style={{'margin-top': '20px'}}>
                        {getI18n()?.formatMessage({id: 'TIMER'}, {mins: timer().min, sec: timer().sec})}
                    </div>
                )}
                <Show when={showDeviceList()}>
                    <DeviceList
                        setShowDeviceList={setShowDeviceList}
                        deviceList={deviceList()}
                        voltApi={props.voltApi}
                        resetStates={props.resetStates}
                        setIsSubmittingOoredoo={props.setIsSubmittingOoredoo}
                        setShowNewLoginForm={props.setShowNewLoginForm}
                        setShowNewLoginOtp={props.setShowNewLoginOtp}
                    />
                </Show>
            </div>
        </div>
    )
}

export default LoginOtp
